<header [class.sticky]="isSticky">
    <button mat-icon-button (click)="toggleSidenav.emit()" *ngIf="isMobile">
        <mat-icon>menu</mat-icon>
    </button>

    <div class="group-switcher" *ngIf="selectedGroup">
        <button mat-button [matMenuTriggerFor]="groupMenu" #groupMenuTrigger="matMenuTrigger" (menuOpened)="onGroupMenuOpened()"
            [attr.title]="selectedGroup?.name">
            <span class="group-name">{{ selectedGroup?.name }}</span>
            <mat-icon iconPositionEnd>arrow_drop_down</mat-icon>
        </button>
        <mat-menu #groupMenu="matMenu" class="group-switcher-menu">
            <div class="group-switcher-menu-search" (click)="$event.stopPropagation()">
                <mat-form-field appearance="outline" class="group-switcher-search-field">
                    <mat-label>Search groups</mat-label>
                    <input matInput
                        [formControl]="groupSearchControl"
                        placeholder="Type to filter…"
                        autocomplete="off"
                        (click)="$event.stopPropagation()"
                        (keydown)="onGroupSearchKeydown($event)">
                    <button mat-icon-button matSuffix type="button"
                        class="group-switcher-clear-search"
                        aria-label="Clear search"
                        *ngIf="groupSearchControl.value"
                        (click)="clearGroupSearch($event)">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </div>
            <button mat-menu-item *ngFor="let group of filteredGroups$ | async" (click)="selectGroupFromMenu(group)">
                {{ group.name }}
            </button>
        </mat-menu>
    </div>

    <div class="demo-notification" *ngIf="showDemoMessage">
        <div class="scrolling-message" [innerHTML]="demoMessage"></div>
    </div>

    <app-system-status-dot></app-system-status-dot>

    <div class="failed-recordings" *ngIf="isBrowser && failedRecordingsCount > 0">
        <button mat-icon-button (click)="openFailedRecordingsDialog()"
            matTooltip="Recordings that have not become notes yet — open to process them">
            <mat-icon [matBadge]="failedRecordingsCount" matBadgeColor="warn" class="bolt-icon">
                warning_amber
            </mat-icon>
        </button>
    </div>

    <app-chat-launcher class="chat-launcher" *ngIf="isBrowser"></app-chat-launcher>

    <div class="notifications">
        <button mat-icon-button [matMenuTriggerFor]="notificationMenu">
            <mat-icon [matBadge]="totalNotifications" [matBadgeHidden]="!totalNotifications" matBadgeColor="warn"
                color="primary">notifications</mat-icon>
        </button>
        <mat-menu #notificationMenu="matMenu" xPosition="before" class="notifications-list">
            <mat-list *ngIf="groupedNotifications.length; else noResults">
                <ng-container *ngFor="let group of groupedNotifications">
                    <mat-list-item class="auto-height m-t-5" [ngClass]="group.notification.completed ? '' : 'disabled'"
                        (click)="handleNotificationClick(group.notification)">
                        <mat-icon matListItemIcon color="primary"
                            *ngIf="group.notification.completed">check_circle</mat-icon>
                        <div matListItemIcon *ngIf="!group.notification.completed"><mat-spinner color="warn"
                                diameter="24"></mat-spinner></div>
                        <div class="notification-title">
                            <div class="notification-name">{{ group.name }}</div>
                            <div class="notification-date">{{
                                group.notification.createdAt | dateDiff }} ago</div>
                        </div>
                        <div class="notification-message">{{ group.notification.message }}</div>
                    </mat-list-item>
                    <mat-divider></mat-divider>
                </ng-container>
            </mat-list>
            <ng-template #noResults>
                <p class="grey-text">No notifications found.</p>
            </ng-template>
        </mat-menu>
    </div>

    <!--
      A SEPARATE control from the bell above, deliberately. That badge counts job progress ("your
      transcription is ready"); this one counts product news and service notices. Merging them
      trains people to ignore both.
    -->
    <!--
      A SEPARATE control from the bell above, deliberately. That badge counts job progress ("your
      transcription is ready"); this one counts product news. Merging them trains people to ignore
      both.

      It does NOT reuse `mat-list` / `.notification-*` like the bell does. Those classes are sized
      for a one-line job status, and a release note has a title, a date and a read state to place —
      which is how it ended up as three cramped wrapped lines with no hierarchy.
    -->
    <div class="announcements" *ngIf="(announcementArchive$ | async)?.length">
        <button mat-icon-button [matMenuTriggerFor]="announcementMenu" aria-label="Announcements">
            <mat-icon [matBadge]="announcementUnread$ | async"
                [matBadgeHidden]="!(announcementUnread$ | async)" matBadgeColor="warn"
                color="primary">campaign</mat-icon>
        </button>

        <mat-menu #announcementMenu="matMenu" xPosition="before" class="announcements-menu">
            <div class="announcement-panel">
                <div class="announcement-panel-header">
                    <mat-icon>campaign</mat-icon>
                    <span class="announcement-headline">What's new</span>
                    <span class="announcement-unread-count" *ngIf="announcementUnread$ | async as unread">
                        {{ unread }} unread
                    </span>
                </div>

                <mat-divider></mat-divider>

                <div class="announcement-list">
                    <button type="button" class="announcement-row"
                        *ngFor="let announcement of announcementArchive$ | async"
                        [class.unread]="announcement.unread"
                        (click)="openAnnouncement(announcement)">
                        <span class="announcement-unread-dot" [class.is-unread]="announcement.unread"
                            aria-hidden="true"></span>
                        <mat-icon class="announcement-type-icon"
                            [ngClass]="'type-' + announcement.type">
                            {{ announcementIcon(announcement.type) }}
                        </mat-icon>
                        <span class="announcement-row-body">
                            <span class="announcement-row-title">{{ announcement.title }}</span>
                            <span class="announcement-row-meta">
                                {{ announcement.publishedAt | dateDiff }} ago
                                <span class="announcement-resolved" *ngIf="announcement.resolved">· retired</span>
                            </span>
                        </span>
                        <mat-icon class="announcement-chevron">chevron_right</mat-icon>
                    </button>
                </div>
            </div>
        </mat-menu>
    </div>

    <!-- On small screens a text button with its label hidden still reserves the label's padding,
         so swap in icon buttons instead of just dropping the text. -->
    <ng-container *ngIf="isMobile; else desktopActions">
        <button mat-icon-button (click)="onSettingsClick()" color="primary" matTooltip="Settings" aria-label="Settings">
            <mat-icon>settings</mat-icon>
        </button>
        <button mat-icon-button (click)="onLogout()" color="primary" matTooltip="Logout" aria-label="Logout">
            <mat-icon>logout</mat-icon>
        </button>
    </ng-container>
    <ng-template #desktopActions>
        <button mat-button (click)="onSettingsClick()" color="primary" class="m-r-5">
            <mat-icon>settings</mat-icon><span>Settings</span>
        </button>
        <button mat-button (click)="onLogout()" color="primary">
            <mat-icon>logout</mat-icon><span>Logout</span>
        </button>
    </ng-template>
</header>

<button mat-fab class="back-to-top" *ngIf="showBackToTop && isBrowser" (click)="scrollToTop()" color="primary">
    <mat-icon>arrow_upward</mat-icon>
</button>
